export enum EOSType {
  ios = 'ios',
  android = 'android',
  other = 'other'
}
